.ux-iws-stateful-filter-tags {
    display: block;

    &__container {
        margin-top: 10px;
    }
}
